import { Box, Typography } from '@mui/material';
import { SyncsSection } from './SyncsSection';

/** `/admin/sync` — a button for everything the toolkit imports or exports on a schedule, with its last run. */
export const AdminSyncPage = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h1" component="h1">
        Syncs
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 720 }}>
        Everything the toolkit imports or exports on a schedule, with its last run. Every sync runs nightly, and
        each can be run now.
      </Typography>
    </Box>

    <SyncsSection />
  </Box>
);
